export default __webpack_public_path__ + "static/media/google.9c61052f.svg";